const REGISTER_HOST_ACTION = 'REGISTER_HOST_ACTION';
const DEREGISTER_HOST_ACTION = 'DEREGISTER_HOST_ACTION';
const ADD_PORTAL_ACTION = 'ADD_PORTAL_ACTION';
const UPDATE_PORTAL_ACTION = 'UPDATE_PORTAL_ACTION';
const REMOVE_PORTAL_ACTION = 'REMOVE_PORTAL_ACTION';
const INITIAL_STATE = {};
export { REGISTER_HOST_ACTION, DEREGISTER_HOST_ACTION, ADD_PORTAL_ACTION, UPDATE_PORTAL_ACTION, REMOVE_PORTAL_ACTION, INITIAL_STATE };
//# sourceMappingURL=constants.js.map